import type { WebMcpBrowserBinding, WebMcpBrowserHandle } from '@bomdisoft/webmcp-core';

interface NavigatorModelContext {
  registerTool(spec: { description: string; handler: (args: unknown) => Promise<unknown>; inputSchema: object; name: string }): Promise<{ unregister(): Promise<void> }>;
  requestConsent?(spec: { description: string; preview: string; toolName: string }): Promise<boolean>;
}

declare global {
  interface Navigator {
    modelContext?: NavigatorModelContext;
  }
}

export function createNavigatorBinding(): WebMcpBrowserBinding {
  return {
    async registerTool(spec) {
      const mc = navigator.modelContext;
      if (!mc) {
        throw new Error('navigator.modelContext is unavailable');
      }
      const handle = await mc.registerTool(spec);
      const wrapped: WebMcpBrowserHandle = { unregister: () => handle.unregister() };
      return wrapped;
    },
    async requestConsent(spec) {
      const mc = navigator.modelContext;
      if (!mc?.requestConsent) return false;
      return mc.requestConsent(spec);
    },
  };
}
